import Player from '@vimeo/player/dist/player.es';

export class VimeoVideoPreview {
    constructor(container) {
        this.iframe = container.querySelector('iframe');
        this.thumbnail = container.querySelector('[data-vimeo-video-preview-image]');
        if (!this.iframe || !this.thumbnail) {
            return;
        }
        this.init();
    }

    init() {
        const player = new Player(this.iframe);

        player.pause();
        this.thumbnail.classList.remove('d-none');

        this.thumbnail.addEventListener('click', () => {
            player.play();
            this.thumbnail.classList.add('d-none');
        });

        player.on('play', () => {
            this.thumbnail.classList.add('d-none');
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
   document.querySelectorAll('[data-vimeo-video-preview]').forEach((videoPreview) => {
      new VimeoVideoPreview(videoPreview);
   });
});
